import { gql } from '@apollo/client';

export const UPDATE_PHARMACY = gql`
  mutation updatePharmacy($data: UpdatePharmacyInput!) {
    updatePharmacy(data: $data)
  }
`;
